module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/venue/venue-template-create/venue-template-create.component.scss
// module id = ./src/app/routes/venue/venue-template-create/venue-template-create.component.scss
// module chunks = 9